var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComputerScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2H2.66683C1.9335 2 1.3335 2.6 1.3335 3.33333V10.6667C1.3335 11.4 1.9335 12 2.66683 12H4.66683L4.00016 12.6667V14H12.0002V12.6667L11.3335 12H13.3335C14.0668 12 14.6668 11.4 14.6668 10.6667V3.33333C14.6668 2.6 14.0668 2 13.3335 2ZM13.3335 10.6667H2.66683V3.33333H13.3335V10.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputerScreen);
export default __webpack_public_path__ + "static/media/icon-computer-screen.38b991d1a854579cb405766e2858e29b.svg";
export { ForwardRef as ReactComponent };